import React, { useState } from "react";
import clsx from "clsx";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b">
      <div className="max-w-[1100px] mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2 font-extrabold text-lg">
          <img src="/logo.png" alt="Daraa Umzug Logo" className="h-20 w-auto" />
      
        </div>

        {/* Desktop-Nav */}
        <nav className="hidden md:flex items-center gap-6 text-sm">
          <a className="hover:underline" href="#preise">Preise</a>
          <a className="hover:underline" href="#services">Leistungen</a>
          <a className="hover:underline" href="#ablauf">Ablauf</a>
          <a className="hover:underline" href="#faq">FAQ</a>
          <a className="hover:underline" href="#kontakt">Kontakt</a>
        </nav>

        {/* Mobile Burger */}
        <button
          className="md:hidden p-3 rounded-lg border aria-expanded:shadow-inner"
          aria-expanded={open}
          aria-label="Menü öffnen"
          onClick={() => setOpen((v) => !v)}
        >
          ☰
        </button>
      </div>

      {/* Mobile Drawer */}
      <div
        className={clsx(
          "md:hidden transition-[max-height] overflow-hidden bg-white border-t",
          open ? "max-h-96" : "max-h-0"
        )}
      >
        <nav className="px-4 py-3 grid gap-3 text-base">
          <a onClick={() => setOpen(false)} href="#preise" className="py-3">Preise</a>
          <a onClick={() => setOpen(false)} href="#services" className="py-3">Leistungen</a>
          <a onClick={() => setOpen(false)} href="#ablauf" className="py-3">Ablauf</a>
          <a onClick={() => setOpen(false)} href="#faq" className="py-3">FAQ</a>
          <a onClick={() => setOpen(false)} href="#kontakt" className="py-3">Kontakt</a>
          <a href="tel:03088677711" className="mt-1 inline-flex items-center justify-center rounded-xl px-4 py-3 font-semibold bg-[#FF6B00] text-white">
            Jetzt anrufen
          </a>
        </nav>
      </div>
    </header>
  );
}
